import React, { useState, useEffect } from "react";
import { Route, Switch, withRouter, useHistory,useLocation } from "react-router-dom";
import classnames from "classnames";
// styles
import useStyles from "./styles";

// components
import Sidebar from "../Sidebar/Sidebar";
import RightSidebar from "../RightSidebar";
import { InnerRightDrawer } from '../RightSidebar/components';


//import BrandLogo from "../BrandLogo";
import ThemeToggler from "../ThemeToggler";

// pages
import { Dashboard, Module, Edit, Detail} from "../../pages";

// context
import { useLayoutState } from "../../context/LayoutContext";

import { Grid, Hidden } from '@material-ui/core';
import { pathOr } from "ramda";



function Layout(props) {
  const [toggleState, setState] = useState({ right: false });
  
  const [openDetailRightBar, setOpenDetailRightBar] = useState({ right: false }, { data: [] });
  const history = useHistory();
  const classes = useStyles();


  const layoutState = useLayoutState();

  const location = useLocation();
  useEffect(() => {
    setOpenDetailRightBar({ right: false }, { data: [] });
  },[location]);
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...toggleState, [anchor]: open });
  };
  const toggleDrawerDetailRightBar = (anchor, open, data) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    let existingName = pathOr('', ["data", "name"], openDetailRightBar);
    let newName = pathOr('', ["name"], data);

  
    if (existingName !== newName && open === false) {
      open = true;
    } else if (existingName === newName && open === false) {
      data['name'] = '';
    }
    setOpenDetailRightBar({ ...openDetailRightBar, [anchor]: open, data });
  };
  const search = ()=>{
    // console.log("search test");
  }
  // console.log('oooooooooooooooooooooooooooooooo')
  return (
    <div className={classes.root}>
      <>
        {/* <Header history={history} /> */}
        {/* <Sidebar history={history} search={()=>search()} /> */}

        <div
          className={
            classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })
            + " " + classnames(classes.contentRightBar, {
              [classes.contentShiftRightBar]: openDetailRightBar['right'],
            })

          }

        >
          <Grid container >
            {/* <Grid container spacing={0} className={classes.BrandLogoBar}> */}
            {/* <Grid item xs={12} className={classes.BrandLogoBackground}>
              <BrandLogo />
            </Grid> */}
            <Grid item xs={12}>

              <div className={classes.fakeToolbar} />
              {/* <FormatPaint
                className={classes.themeIcon}
                onClick={toggleDrawer("right", true)}
              /> */}
              {/* <ThemeToggler toggleDrawer={toggleDrawer} toggleState={toggleState} /> */}
              <Switch>
                <Route path="/app/Home" component={Dashboard} exact />
                <Route path='*' exact={true} component={Dashboard} />
                {/* <Route path="/app/Example/Demo" component={Demo} exact /> */}
                {/* <Route path="/app/Example/ShowcaseLayout" component={ShowcaseLayout} exact /> */}
                {/* <Route path="/app/:module" component={Module} exact /> */}
                
                {/* <Route path="/app/:module/:view/:returnModule/:returnRecord" component={Module} exact /> */}
                {/* <Route path="/app/createview/:module" component={Edit} exact />
                <Route path="/app/createrelateview/:module/:returnModule/:returnRecord/:recordName" component={Edit} exact />
                <Route path="/app/duplicateview/:module/:id" component={Edit} exact />
                <Route path="/app/convert/:module/:id/:returnModule" component={Edit} exact />
                <Route path="/app/editview/:module/:id" component={Edit} exact />
                <Route path="/app/convertlead/:module/:id" component={Edit} exact />

                <Route
                  path="/app/detailview/:module/:id"
                  component={Detail}
                  exact
                />
                <Route
                  path="/app/detailview/:module/:id/:msgno/:uid"
                  component={Detail}
                  exact
                /> */}
              </Switch>
            </Grid>
          </Grid>
        </div>
        {/* <Hidden xsDown={true}>
          <InnerRightDrawer key="innerRightBar" toggleDrawerDetailRightBar={toggleDrawerDetailRightBar} openDetailRightBar={openDetailRightBar} setOpenDetailRightBar={setOpenDetailRightBar} history={history} />
          <RightSidebar key="rightBar" toggleDrawer={toggleDrawer} toggleDrawerDetailRightBar={toggleDrawerDetailRightBar} openDetailRightBar={openDetailRightBar} setOpenDetailRightBar={setOpenDetailRightBar} history={history} />
        </Hidden> */}
      </>
    </div>
  );
}

export default withRouter(Layout);
